import { importer } from "./importer";
import { checkNested } from "./general_functions";
import language from "./translation";

// import $ from "jquery";
// import "@prokom/edoc-viewer/prod/viewer.min.js";


export const skjema_overview = (viewer) => {


    let r = `
    
            <div class="container">
                <div class="row justify-content-sm-center">
                    <div class="col-sm-9">
                        <div class="form__container" id="formcontainer">
                        </div>
                    </div>
                </div>
            </div>
        
    
    `;

    $("#maincontent").html(r);


    let clientname = client.nameId;

    importer([
        "/edoc/viewer.min.js",
        // "/edoc/viewer.min.css"
    ]).then(function() {

        // console.log("starter render");

        $("#formcontainer").html(`
                        
                            <h1>Hei ${user.firstName},</h1>
                        
                            <a class="float-right" href="/skjema/logout">Logg ut</a>
                            
                            <p>Her finner du en oversikt over dine lagrede skjema.</p>
                            
                            <div id="myforms"></div>
                            
                            
                            
        `);

        viewer.getCases().then(cases => {


            // console.log("test", cases);


            let forms = [];

            let formHtml = (form, saved = false) => {

                let url = `/skjema/pdf/${form.refId}`;
                if (saved)
                    url = `/skjema/open/${form.refId}`;

                // console.log(saved,"saved");
                return `
                    <tr id="caseline_${form.refId}">
                        <td><a href="/skjema/open/${form.refId}">${form.name}</a></td>
                        <td>${form.updatedOn}</td>
                        <td>${saved ? `Lagret` : `Innsendt`}</td>
                        <td><button class="btn btn-danger deleteForm " data-id="${form.refId}">Slett</button></td>
                    </tr>
                    `;
            }

            cases.num = cases.saved.length + cases.submitted.length;

            cases.saved.forEach(form => {

                // console.log(form);
                forms.push(formHtml(form, true))

            });

            cases.submitted.forEach(form => {

                // console.log("submitted",form);

                forms.push(formHtml(form))


            });

            forms = forms.join("");

            // console.log("caseslength ", cases.num);

            let r = ``;

            if (cases.num) {
                r = `
                <table class="table">
                    <thead>
                        <tr>
                            <th>Skjema</th>
                            <th>Lagret</th>
                            <th colspan=2>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${forms}
                    </tbody>
                </table>
            `;
            }
            else {
                r = `
                <p>
                    Du har ingen lagrede eller innsendte skjema å vise. Gå til <a href="/skjema/alle">skjemaoversikten</a> for å legge inn et nytt skjema.
                </p>`;
            }


            $("#myforms").html(r);

            $(".deleteForm").click(function() {

                let id = $(this).data("id")
                //   console.log(id);

                viewer.deleteCase(id);

                $("#caseline_" + id).remove();

            });

        });

        // viewer.renderMyCasesTo(document.getElementById("myforms"), location.origin)

    });




}


export const skjema_logoutconfirmation = () => {

    let r = `
            <div class="container">
                <div class="row justify-content-sm-center">
                    <div class="col-sm-9">
                        <div class="form__container">
                            <h1>Du er logget ut</h1>
                            <p>Du er nå logget ut av siden. For å se dine saker kan du logge inn igjen på <a href="/skjema/mine">mine skjema</a></p>
                            <p>Gå til <a href="/">forsiden</a></p>
                        </div>
                    </div>
                </div>
            </div>`;

    $("#maincontent").html(r);

}


export const skjema_login = (viewer, returnurl) => {

    let triedLoop = 0;
    if(sessionStorage.getItem("loginLoops")){
        // console.log("has loginLoops")
        triedLoop = sessionStorage.getItem("loginLoops");
        // alert("trying" + triedLoop);
    }
    if(triedLoop < 1){
        // console.log("triedLoop + 1")
        sessionStorage.setItem("loginLoops", triedLoop + 1);
        viewer
            .logIn({
                securityLevel: 3,
                returnUrl: returnurl
            });
    }
    else {
        // console.error("System reject error");
        
        // alert("testing response");
        

        let clientname = client.nameId;

        if(client.skjema){
            if(client.skjema.id){
                clientname = client.skjema.id;
            }
        }
        
        console.error("Login issues skjema");
        
        setTimeout(function(){
        $("#formcontainer").prepend(`
            
            <p>
                Skjema innlogging feilet. Gå til <a href="https://skjema.no/${clientname}/" target=_blank>https://skjema.no/${clientname}/</a>
            </p>
            <p>
            
                Om du ønsker å prøve igjen, kan du logge ut ved å klikke <a href="/skjema/logout">her</a>
            </p>
        
        `)},1500)
    }

}

export const skjema_logout = (viewer) => {

    console.log("remove loginLoops");
    sessionStorage.removeItem("loginLoops");
    
    viewer.logOut(location.origin + "/skjema/logoutconfirmation");

}

export const skjema_all = (viewer) => {

    viewer.getForms().then(forms => {


        // console.log(forms);

        let allforms = [];

        forms.forEach(form => {

            allforms.push(`
            
                <p><a href="/skjema/${form.formId}">${form.name}</a></p>
            
            `)

        });

        allforms = allforms.join("")



        let r = `
            <div class="container">
                <div class="row justify-content-sm-center">
                    <div class="col-sm-9">
                        <div class="form__container">
                            <div id="skjema_page">
                            
                            
        
                                <h1>Alle skjema</h1>
                                <p>Her finner du oversikt over alle skjema kommunen har tilgjengelige.</p>
                                
                                ${allforms}
                            
                            
                            </div>
                        </div>
                    </div>
                </div>
            </div>`;

        $("#maincontent").html(r);


    });

}

export const skjema_page = (client) => {

    // console.log("client", client);

    const formid = getPageUrl().contentid;


    let r = `
            <div class="container">
                <div class="row justify-content-sm-center">
                    <div class="col-sm-9">
                        <div class="form__container">
                            <div id="skjema_page"></div>
                        </div>
                    </div>
                </div>
            </div>`;

    $("#maincontent").html(r);

    // console.log("clientId", client.nameId);

    let id = client.nameId

    if (checkNested(client, "skjema", "id")) {

        id = client.skjema.id;

    }

    // console.log("id",id);



    importer([
        "/edoc/viewer.min.js",
        // "/edoc/viewer.min.css"
    ]).then(async function() {


        let clientname = client.nameId;

        if(client.skjema){
            if(client.skjema.id){
                clientname = client.skjema.id;
            }
        }
        
        // console.log(clientname);

        // console.log(clientname);

            viewer.init({
                apiUrl: "https://api.skjema.no",
                customerId: clientname,
                skipReadAndAcceptedPrivacy: true
            });


        if (formid === "logout") {

            return skjema_logout(viewer);

        }

        if (formid === "logoutconfirmation") {

            return skjema_logoutconfirmation();

        }

        if (formid === "alle") {

            return skjema_all(viewer);
        }
        
        
        const user = await viewer.getAuthenticatedUser();
        
        const testlogin = (user, viewer) => {
            

            // finne ut om skjema trenger pålogging.
    
            window.user = user;
    
            if (!user) {
            //     if (!sessionStorage.getItem("userLoop")) {
                    skjema_login(viewer, location.href);
            //     }
            }
        }


        if (formid.match(/open/gmi)) {
            
            testlogin(user, viewer);
            

            let open = formid.split("/");

            // console.log("open", open);

            loadFrom("skjema_page", 0, open[1])

            return;

        }


        if (formid.match(/pdf/gmi)) {

            let open = formid.split("/");

            // console.log("open", open);
            
            viewer.getPdf(open[1]);

            // loadFrom("skjema_page", 0, open[1])

            return;

        }


        if (formid === "login") {

            return skjema_login(viewer, location.href);

        }

        if (formid === "mine") {
            
            testlogin(user, viewer);
            // console.log("before overivew");
            return skjema_overview(viewer);
        }

        loadFrom("skjema_page", formid);

    });

}
export const loadFrom = (containerid, formid, refid) => {


    // document.addEventListener("DOMContentLoaded", function() {

    let config = {
        divId: containerid,
        onSubmitted: function(receipt) {
            $("#" + containerid).html(`
                    
                    ${language("FORM_RECEIVED_FEEDBACK", receipt.refId)}
                            
                                <div id="receivedform_info">
                                </div>
                            
                            `)





            // });


        },
        // onAborting: function(proceed) {
        //     $("#"+containerid).html(language("ABORT"));
        // },
        onAborted: function() {
            $("#" + containerid).html(language("CANCELED_FORM") + `
                <p>
                    <a href="/skjema/mine">Gå tilbake til mine skjema</a>
                
                </p>`);
        },
        // onSaving: function(proceed) {
        //     $("#"+containerid).html(language("SAVING"));
        // },
        onSaved: function(savedData) {

            // console.log("info", savedData)

            $("#" + containerid).html(`
            
            
            ${language("SAVED_FORM")}
            
            <a href="/skjema/mine">Mine skjema</a>
            
            
             <div id="receivedform_info">
            </div>
                            
            
            `);



        },
    };

    if (formid > 0) {
        config.formId = formid;
    }
    if (refid) {
        config.refId = refid;
    }

    viewer.form(config);


    // });

}
export const skjema_link = (content) => {

    // Kariadmin replace aim:48fd4a02-9fc1-4c87-b99e-355c1da495de   Arbeidsvarslingsplan for vei-/gravarbeid, skjema eller infoside

    // console.log("pre content", content);

    content = content.replace(/href\=\"aim:skjema:/gmi, "href\=\"\/skjema\/");
    content = content.replace(/href\=\"\/artikkel\/skjema:/gmi, "href\=\"\/skjema\/");
    content = content.replace(/href\=\"skjema:/gmi, "href\=\"\/skjema\/");

    // console.log("test");


    return content;

}
export const skjema_inline = (client) => {

    const formid = $("#inline-skjema").data("skjemaid");

    if ($("#inline-skjema").length > 0) {

        // console.log(client.nameId);

        loadFrom("inline-skjema", formid);

    }

}
